import Vue from 'PublicJs/vue-bootstrap';
import FeaturedProjectBanner from 'PublicJs/Components/Projects/FeaturedProjectBanner';

new Vue({
	el: '#search-agenda',
	components: {
		FeaturedProjectBanner
	},
});
